export default {"src":"/_next/static/media/dapper-iso-logo-dark.66e030ab.svg","height":514,"width":502,"blurWidth":0,"blurHeight":0};